<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a href="javascript:void(0)" @click="goBack()"> 投票列表 </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="currentSpan">投票结果汇总</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div></div>
    </div>
    <div class="main_body" v-loading="loading">
      <div class="form_bar">
        <div class="form_bar_search"></div>
        <div class="form_bar_btn">
          <el-button type="text" @click="goBack()" v-if="false">
            返回投票列表
          </el-button>
          <el-button type="primary" @click="refresh()" size="small" plain>
            刷新
          </el-button>
          <el-button
            type="primary"
            @click="exportExcel()"
            v-show="voteResults.length > 0"
            size="small"
            plain
          >
            导出
          </el-button>
        </div>
      </div>
      <div class="table-block" style="border-top: 0px">
        <el-empty
          description="暂无数据"
          v-show="voteResults.length === 0"
        ></el-empty>
        <el-collapse
          v-model="activeNames"
          @change="handleChange"
          v-show="voteResults.length > 0"
        >
          <el-collapse-item
            :name="item.VoteId"
            v-for="(item, index) in voteResults"
            :key="index"
          >
            <template slot="title">
              <div v-html="item.VoteName"></div>
            </template>
            <el-table
              :data="item.VoteProjectList"
              highlight-current-row
              style="width: 100%"
            >
              <el-table-column property="Ranking" label="排名" width="50">
              </el-table-column>
              <el-table-column
                label="原序号"
                width="60"
                align="center"
                key="ProjectSort"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.ProjectSort }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="姓名/项目"
                width="150"
                align="left"
                key="ProjectName"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.ProjectName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="单位名称"
                min-width="150"
                align="left"
                key="Remark"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.Remark }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="推荐信息"
                min-width="120"
                align="left"
                key="Remark1"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.Remark1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="item.FirstVoteItemBeforeTitle"
                width="130"
                align="center"
                key="VoteFirstNum"
                v-if="item.VoteType === 0"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.VoteFirstNum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="item.FirstVoteItemTitle"
                width="130"
                align="center"
                key="VoteNum"
                v-if="item.VoteType === 0"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.VoteNum }}</span>
                  <span v-if="scope.row.ProjectRecordState">
                    （{{ scope.row.ProjectRecordState }}）
                  </span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="是否通过"
                width="90"
                align="center"
                key="ProjectRecordState"
                v-if="item.VoteType === 0"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.ProjectRecordState }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                v-for="(item, index) in item.ShortlistHeader"
                :key="index"
                :label="item"
                width="90"
                align="center"
              >
                <template slot-scope="scope">
                  <div
                    v-for="(itme2, index2) in scope.row.ProjectStateList"
                    :key="itme2.Key"
                  >
                    <span v-if="index2 === index">{{ itme2.VoteNumbers }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="基础分数"
                width="100"
                align="center"
                v-if="item.IsShowBasicScore && item.VoteType === 2"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.ProjectBasicScore }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="分数（权重前）"
                width="120"
                align="center"
                key="ScoreBeforeWeight"
                v-if="item.VoteType === 2"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.ScoreBeforeWeight }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="分数（权重后）"
                width="120"
                align="center"
                key="AllScore"
                v-if="item.VoteType === 2"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.AllScore }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="总排序"
                width="120"
                align="center"
                key="VoteNum"
                v-if="item.VoteType === 1"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.VoteNum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="名次"
                width="120"
                align="center"
                key="RankingText"
                v-if="item.VoteType === 1"
              >
                <template slot-scope="scope">
                  <span>第{{ scope.row.Ranking }}名</span>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import voteManageApi from '../../../../api/vote/voteManage'
export default {
  data () {
    return {
      activeNames: [],
      voteResults: [],
      loading: true,
      meetingInfo: {}
    }
  },
  methods: {
    handleChange (val) {
      // console.log(val);
    },
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    refresh: function () {
      this.getVoteResults()
    },
    getVoteResults: function () {
      const _this = this
      _this.loading = true
      voteManageApi.getVoteResults({
        mettingId: _this.$route.params.mid
      }).then(data => {
        _this.voteResults = data
        _this.loading = false
      }).catch(err => {
        _this.loading = false
        return err
      })
    },
    exportExcel: function () {
      const _this = this
      const openLoading = _this.openLoading('正在导出…')
      voteManageApi.exportVoteResults({
        MettingId: _this.$route.params.mid
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '投票汇总'
        if (_this.meetingInfo.MeetingName) {
          fileName = _this.meetingInfo.MeetingName + '-投票汇总'
        }
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    getMeetingVoteInfo: function () {
      this.$api.meetingManage.getMeetingVoteInfo({
        meetingID: this.$route.params.mid
      })
        .then(data => {
          this.meetingInfo = data
        }).catch(err => {
          return err
        })
    }
  },
  created () {
    this.getVoteResults()
    this.getMeetingVoteInfo()
  }
}
</script>
<style lang="less">
.el-collapse-item__header {
  height: auto;
  line-height: inherit;
  background-color: #ff6600;
  padding: 6px 10px;
  font-weight: 700;
}
.el-collapse-item__header i {
  color: #fff;
  font-weight: 700;
}
</style>
